import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
toast.configure();

function CreateSiteSetting() {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
      ["code-block"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
    "code-block",
  ];

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const history = useHistory();
  const [key, setKey] = useState();
  const [value, setValue] = useState();
  const [image, setImage] = useState();


  useEffect(() => {
    let token = localStorage.getItem("token");
  }, []);

  const onKeyChange = (e) => {
    setKey([e.target.value]);
  };
  const onValueChange = (e) => {
    setValue([e.target.value]);
  };


  const onImageChange = (event) => {
    if (!event.target.files[0]) {
      return false;
    } else {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      setImage(files[0]);
    }
  };
  
  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
      formData.append("key", key);
      formData.append("value", value);

      axios
        .post(URL_API + "auth/admin/site-setting", formData)
        .then((response) => {
          if (response.status == 200) {
            history.push("/admin/site-setting");
            toast.success("Site Setting Key/Value Added Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
          }
        })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Add Key Value</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Key
                  </label>
                  <Input
                    name="phone"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    onChange={(e) => onKeyChange(e)}
                  />
                </div>
                <br />
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Value
                  </label>
                  <Input
                    name="phone"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    onChange={(e) => onValueChange(e)}
                  />
                </div>
                
                {/* <div className="form-group">
                  <label
                    htmlFor="post-description"
                    className={styles.labelPostForm}
                  >
                    Ad Description{" "}
                    <span className={styles.blogFormDesciptionSpan}>
                      Enter long description for your project
                    </span>
                  </label>
                  <Input
                    component="textarea"
                    name="article_text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-description"
                    rows="8"
                    onChange={(e) => onDescChange(e)}
                    required
                  />
                </div> */}
                {/* <h1>React Editors</h1>
                <h2>Start editing to see some magic happen!</h2>
                <div
                  style={{
                    border: "1px solid black",
                    padding: "2px",
                    minHeight: "400px",
                  }}
                >*
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                  />
                </div> */}

             
                {/* <div className="form-group">
                  <label htmlFor="post-Images" className={styles.labelPostForm}>
                    Add Photo
                  </label>
                  <Input
                    id="file"
                    type="file"
                    name="image"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    onChange={(e) => onImageChange(e)}
                    required
                  />
                </div> */}
                <br />
                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default CreateSiteSetting;
